import hofCookie from './cookie-data';
import hofEnv from './environment';
import storage from './local-storage';
import '../vendor/add-to-homescreen';

export function hofAddHomeScreen() {
	const isStandalone =
		window.navigator.standalone ||
		screen.height - document.documentElement.clientHeight < 40 ||
		window.matchMedia('(display-mode: standalone)').matches;

	let chrome =
		hofEnv.isAndroid && /chrom(e|ium)/.test(hofEnv.browserName.toLowerCase());

	if (hofEnv.isNativeAndroid && hofEnv.engineVersion.major < 537) {
		chrome = false;
	}

	const showInPage = true;
	let count = undefined;

	try {
		count = storage.get('org.cubiq.addtohome');
	} catch (e) {}

	let countNum = 0;
	let maxNum = 5;
	const time = 20160;
	if (count) {
		countNum = count.displayCount;
	}
	if (countNum >= 5) {
		maxNum = 0;
	}

	const cookie = hofCookie.has('OptanonAlertBoxClosed');
	if (cookie) {
		if (
			(hofEnv.isSafari ||
				(hofEnv.isAndroid && hofEnv.isValidAndroid && chrome)) &&
			showInPage &&
			!isStandalone
		) {
			addToHomescreen({
				startDelay: 0,
				lifespan: 7,
				debug: !isHofProd,
				maxDisplayCount: maxNum,
				displayPace: time,
				icon: true,
				modal: true,
				detectHomescreen: true,
			});
		}
	} else {
		window.addEventListener('beforeinstallprompt', (e) => {
			e.preventDefault();
		});
	}
}
